<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import { ModelListSelect } from "vue-search-select";
/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "LPO Stocking",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, ModelListSelect },
  data() {
    return {
      title: "LOCAL PURCHASE ORDER STOCKING",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "LPO Stocking",
          active: true,
        },
      ],
      id: this.$route.params.id,
      data: {
        orderId: this.$route.params.id,
        amount_paid: 0,
        total_amount: "",
        payment_mode: "",
      },

      editQuantity: {
        orderId: this.$route.params.id,
        quantity: 0,
        order_qty: "",
        item_name: "",
        id: "",
        expiry: "",
        batch: "",
      },

      modal_id: "",
      expiryError: "",
      batchError: "",
      qtyError: "",
      amtError: "",
      modeError: ""
    };
  },
  computed: {
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("purchaseOrder", ["purchaseOrder", "GeneratingStatus"]),
    ...mapGetters("auth", ["user_permissions"]),
    ...mapGetters("payments", ["PaymentModes"]),
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.notificationtype == "success") {
          this.closeModal(this.modal_id);
          this.resetData();
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchOrder: "purchaseOrder/fetchPurchaseOrderDetails",
      addQuantity: "purchaseOrder/addQuantity",
      addLPOStock: "purchaseOrder/LPOStocking",
      FetchModes: "payments/fetchPaymentModes",
    }),

    setQuantity(record){
      this.editQuantity.order_qty = record.quantity;
      this.editQuantity.quantity = record.supplied_qty;
      this.editQuantity.item_name = record.item;
      this.editQuantity.id = record.id;
      this.editQuantity.batch = record.batch_number;
      this.editQuantity.expiry = record.expiry_date;
    },

    saveQuantity(modalId) {
      this.modal_id = modalId;
      if (this.editQuantity.quantity == "" || this.editQuantity.quantity < 1) {
        this.qtyError = "Supplied quantity field is required";
        return;
      } else {
        this.qtyError = "";
      }

      if (this.editQuantity.batch == "") {
        this.batchError = "Batch Number field is required";
        return;
      } else {
        this.batchError = "";
      }

      if (this.editQuantity.expiry == "") {
        this.expiryError = "Batch Expiry Date field is required";
        return;
      } else {
        this.expiryError = "";
      }

      let ToDate = new Date();
      if (new Date(this.editQuantity.expiry).getTime() < ToDate.getTime()) {
        this.expiryError = "Batch Expiry Date cannot be in the past";
        return ;
      }else {
        this.expiryError = "";
      }

      if (parseInt(this.editQuantity.quantity) > parseInt(this.editQuantity.order_qty)) {
        this.qtyError = "Supplied quantity cannot be more than the ordered quantity";
        return;
      } else {
        this.qtyError = "";
      }

      this.addQuantity(this.editQuantity);
    },

    stockingModel(){
      this.data.total_amount = this.purchaseOrder.supply_total;
      this.data.amount_paid = 0;
    },

    saveStock(modalId) {
      this.modal_id = modalId;
      if (this.data.amount_paid == "") {
        this.amtError = "Amount paid field is required";
        return;
      } else {
        this.amtError = "";
      }

      if (this.data.amount_paid > this.data.total_amount) {
        this.amtError = "Amount paid cannot be more than Total of the supplied";
        return;
      } else {
        this.amtError = "";
      }

      if (this.data.payment_mode == "") {
        this.modeError = "Payment Method field is required";
        return;
      } else {
        this.modeError = "";
      }

      this.addLPOStock(this.data);
    },

    resetData() {
      this.modal_id = "";
      this.editQuantity.quantity = 0;
      this.editQuantity.order_qty = "";
      this.editQuantity.item_name = "";
      this.editQuantity.id = "";
      this.editQuantity.batch = "";
      this.editQuantity.expiry = "";
      this.data.total_amount = "";
      this.data.amount_paid = "0";
    },

    resetErrors() {
      this.qtyError = "";
      this.expiryError = "";
      this.batchError = "";
      this.amtError = "";
      this.modeError = "";
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchOrder(this.id);
    this.FetchModes();
  },
};
</script>

<style scoped>
</style>

<template>
  <Layout>
    <Toasts
        :show-progress="true"
        :rtl="true"
        :max-messages="20"
        :time-out="3000"
        :closeable="false"
        :solid="true"
    ></Toasts>
    <div class="row">
      <div class="col-lg-12">
        <div>
          <div class="float-end">
            <div class="btn-group" v-if="purchaseOrder.orderStatus==1">
              <button v-b-modal.confirm-stock class="btn btn-info" @click="stockingModel()">
                <i class="fa fa-check-double"></i> Confirm Received
              </button>
            </div>
          </div>
        </div>
        <div>
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-circle-left"></i> Go Back
          </button>
        </div>

        <div class="bg-white text-dark">
          <div class="m-2 text-dark" v-if="!purchaseOrder.clinicLogo">
            <div style="text-align: center;">
              <b-spinner
                  class="m-0"
                  variant="primary"
                  role="status"
              ></b-spinner>
            </div>
          </div>
          <div class="m-2 text-dark" v-else>
            <div style="width: 100%; top: 0; height: 130px">
              <div style="width: 50%; float: left; top: 0px">
                <h3 class="text-uppercase text-start">
                  <strong>PURCHASE ORDER</strong>
                </h3>
                <table width="100%">
                  <tr align="left">
                    <td><strong>ORDER CODE: </strong> {{purchaseOrder.orderCode}}</td>
                  </tr>
                  <tr align="left">
                    <td>
                      <strong>ORDER DATE:</strong>
                      {{ purchaseOrder.orderDate }}
                    </td>
                  </tr>
                  <tr align="left">
                    <td>
                      <strong>TOTAL AMOUNT:</strong>
                      {{ purchaseOrder.supply_total }}
                    </td>
                  </tr>
                </table>
              </div>
              <div style="width: 50%; float: right; top: 0px">
                <h3 class="text-uppercase">
                  <strong>SUPPLIER</strong>
                </h3>
                <table width="100%">
                  <tr>
                    <td>{{purchaseOrder.orderSupplier.name ? purchaseOrder.orderSupplier.name : "---"}}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Tel:</strong>
                      {{ purchaseOrder.orderSupplier.contact }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Email:</strong>
                      {{ purchaseOrder.orderSupplier.email }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>


            <table width="100%" class="table table-striped" style="font-size: 15px">
              <thead>
              <tr>
                <th>S/N</th>
                <th>Item</th>
                <th>Ordered</th>
                <th>Supplied</th>
                <th>Unit Price</th>
                <th>Total</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(record, r) in purchaseOrder.orderItems" :key="r">
                <td>{{ r + 1 }}</td>
                <td>{{ record.item }}</td>
                <td>{{ record.quantity }}</td>
                <td>{{ record.supplied_qty }}</td>
                <td>{{ record.unit_price }}</td>
                <td><strong>{{ record.final_amount }}/=</strong></td>
                <td>
                  <button v-if="record.supplied_qty > 0" v-b-modal.confirm-quantity @click="setQuantity(record)" class="btn btn-success btn-sm">
                    <i class="fa fa-edit"></i> Edit
                  </button>
                  <button v-if="record.supplied_qty < 1" v-b-modal.confirm-quantity @click="setQuantity(record)" class="btn btn-info btn-sm">
                    <i class="fa fa-check"></i> Confirm
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- Confirm LPO stocking modal starts -->
    <b-modal id="confirm-stock" hide-footer @hidden="resetData">
      <template #modal-title> CONFIRM STOCKING OF LPO</template>
      <div class="form-group mb-3">
        <label>Amount paid</label>
        <input
            type="text"
            class="form-control"
            v-model="data.amount_paid"
            @input="resetErrors()"
            placeholder="Enter batch number"/>
      </div>
      <div class="text-danger" v-if="amtError">
        <em>{{ amtError }}</em>
      </div>

      <div class="form-group">
        <label>Payment Method</label>
        <model-list-select
            :list="PaymentModes ? PaymentModes : []"
            v-model="data.payment_mode"
            option-value="id"
            option-text="modeName"
            placeholder="Select payment Method"
            @input="resetErrors()"
        >
        </model-list-select>
      </div>
      <div class="text-danger" v-if="modeError">
        <em>{{ modeError }}</em>
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('confirm-stock')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-primary" @click="saveStock('confirm-stock')">
          <i class="fa fa-check"></i>
          Save Changes
          <b-spinner
              v-if="GeneratingStatus"
              variant="light"
              small
              label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- Confirm Item quantity modal starts -->
    <b-modal id="confirm-quantity" hide-footer @hidden="resetData">
      <template #modal-title>
        <span class="text-uppercase">Confirm <code>{{editQuantity.item_name}}</code> supplied</span>
      </template>
      <div class="form-group mb-3">
        <label>Enter supplied quantity</label>
        <input
            type="number"
            class="form-control"
            v-model="editQuantity.quantity"
            @input="resetErrors()"
            placeholder="Enter supplied quantity"
        />
      </div>
      <div class="text-danger" v-if="qtyError">
        <em>{{ qtyError }}</em>
      </div>

      <div class="form-group mb-3">
        <label>Enter Batch Number</label>
        <input
            type="text"
            class="form-control"
            v-model="editQuantity.batch"
            @input="resetErrors()"
            placeholder="Enter batch number"
        />
      </div>
      <div class="text-danger" v-if="batchError">
        <em>{{ batchError }}</em>
      </div>
      <div class="form-group mb-3">
        <label>Enter Expiry Date</label>
        <input
            type="date"
            class="form-control"
            v-model="editQuantity.expiry"
            @input="resetErrors()"
            placeholder="Enter expiry date"
        />
      </div>
      <div class="text-danger" v-if="expiryError">
        <em>{{ expiryError }}</em>
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('confirm-quantity')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-primary" @click="saveQuantity('confirm-quantity')">
          <i class="fa fa-check"></i>
          Confirm
          <b-spinner
              v-if="GeneratingStatus"
              variant="light"
              small
              label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- end row -->
  </Layout>
</template>
